import { useEffect, useState } from "react";
import { getGameQuizzes } from "../services/gameQuiz/gameQuiz.service";
import { GameQuizEntity } from "../services/gameQuiz/gameQuiz.types";

export interface GameQuizMinimal {
  id: number;
  title: string;
}

export const useGameQuizzesSelector = () => {
  const [gameQuizzes, setGameQuizzes] = useState<GameQuizMinimal[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchGameQuizzes = async () => {
    setLoading(true);
    try {
      const response = await getGameQuizzes({
        page: 1,
        pageSize: 1000,
        published: true,
      });
      setGameQuizzes(
        response.data.map((q: GameQuizEntity) => ({
          id: q.id,
          title: q.title,
        })),
      );
    } catch (error) {
      console.error("Error fetching game quizzes for selector:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGameQuizzes();
  }, []);

  return {
    gameQuizzes,
    loading,
    refetch: fetchGameQuizzes,
  };
};
